module.exports = __webpack_public_path__ + "img/photo_plus.ada8e324.png";